(function (module) {
    'use strict';

    function titleDirective ($rootScope, $filter) {
        return {
            link: () => {
                var listener = (event, toState) => {
                    if (toState.data && toState.data.pageTitle) {
                        $rootScope.pageTitle = 'Signage Rocket - ' + $filter('translate')(toState.data.pageTitle);
                    } else {
                        $rootScope.pageTitle = 'Signage Rocket';
                    }
                };
                $rootScope.$on('$stateChangeSuccess', listener);
            }
        };
    }

    module.directive('title', titleDirective);

})(angular.module('rocket.components'));
